<template>
  <div class="columns">
    <div class="column is-12">
      <div>
        <svg :height="line_creator.box_styles.height" :width="line_creator.box_styles.width">
          <g v-for="(line,line_i) in line_creator.lines_cordinates" :key="line_i" :transform="`translate(${line_creator.box_styles.width/2},${line_creator.box_styles.height/2}) scale(1,-1)`">
            <path :style="strokeStyle" :d="makeLine(line)"/>
            <path :style="startArrowStyle(line)" :d="makeStartArrow(line)"/>
            <path :style="endArrowStyle(line)" :d="makeEndArrow(line)"/>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {  
  },
  name: "show-line-creator",
  props: {
    line_creator: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  methods:{
    makeLine(line){
      let d = [
          "M", line.start.x, line.start.y, 
          "L", line.end.x, line.end.y
      ].join(" ");
      return d;
    },
    makeStartArrow(line){
      let d = [
          "M", line.start.x-10, line.start.y-10, 
          "L", line.start.x, line.start.y,
          "L", line.start.x+10, line.start.y-10
      ].join(" ");
      
      if(line.start.y<line.end.y){
        d = [
          "M", line.start.x-10, line.start.y+10, 
          "L", line.start.x, line.start.y,
          "L", line.start.x+10, line.start.y+10
        ].join(" ");
      }
      return d;
    },
    makeEndArrow(line){
      let d = [
          "M", line.end.x-10, line.end.y+10, 
          "L", line.end.x, line.end.y,
          "L", line.end.x+10, line.end.y+10
      ].join(" ");

      if(line.start.y<line.end.y){
        d = [
            "M", line.end.x-10, line.end.y-10, 
            "L", line.end.x, line.end.y,
            "L", line.end.x+10, line.end.y-10
        ].join(" ");
      }
      return d;
    },
    angle(line){
      let tangent=(line.end.y-line.start.y)/(line.end.x-line.start.x);
      let angle=Math.atan(tangent) * (180/Math.PI);
      if(angle<0)
      {
        angle=180+angle;
      }
      return angle;
    },
    // point(line){
    //   let tangent=(line.end.y-line.start.y)/(line.end.x-line.start.x);
    //   let x=line.start.x - line.start.y/tangent;
    //   return x;
    // },
    startArrowStyle(line){
      return{
        "transform-origin":`${line.start.x}px ${line.start.y}px`,
        "transform": `rotate(${this.angle(line)-90}deg)`,
        ...this.strokeStyle
      }
    },
    endArrowStyle(line){
      return{
        "transform-origin":`${line.end.x}px ${line.end.y}px`,
        "transform": `rotate(${this.angle(line)-90}deg)`,
        ...this.strokeStyle
      }
    },
  },
  computed:{
    strokeStyle(){
      return{
        "stroke":`${this.line_creator.line_styles.bg_color}`,
        "stroke-width":`${this.line_creator.line_width}`,
        "fill":"none"
      }
    },
    boxStyles(){
      return{
          ...getCSSFromStyles(this.line_creator.box_styles),
      }
    },      
  }
};
</script>
<style scoped>
</style>